import { useState, useEffect } from "react";
import PageTitle from "./../../../components/common/pageTitle/PageTitle";
import { useNavigate } from "react-router-dom";
import { useRecommendHall } from "./../../../utils/hooks/useRecommendHall";
import { setMealType } from "@src/@slice/recommendHallSlice";

import buffet from "@assets/images/recommend/weddinghall/meal_buffet.jpg";
import course from "@assets/images/recommend/weddinghall/meal_course.jpg";
import table from "@assets/images/recommend/weddinghall/meal_table.jpg";
import ImageSelectableCard from "@src/components/recommend/ImageSelectableCard";
import CustomHeader from "@src/components/common/appHeader/CustomHeader";
import StopRecommend from "./_component/StopRecommend";

const mealTypeItems = [
  { title: "뷔페", subTitle: "다양한 메뉴를 개인이 선택", src: buffet },
  { title: "코스", subTitle: "차례로 나오는 고급 메뉴들", src: course },
  { title: "한상차림", subTitle: "한상에 정갈하게 차린 식사", src: table },
];

const MealType = () => {
  const navigate = useNavigate();
  const [validate, setValidate] = useState(false);
  const [showStopModal, setShowStopModal] = useState(false);
  const { hallData, dispatch } = useRecommendHall();

  useEffect(() => {
    setValidate(hallData.meal.types.length > 0);
  }, [hallData.meal.types]);

  const goNext = () => {
    navigate("/recommend/hall/cost");
  };

  return (
    <div className="recommend-hall-page recommend-hall-selection">
      <CustomHeader goBack={() => navigate("/recommend/hall/visitor")} close={() => setShowStopModal(true)} />
      <StopRecommend showStopModal={showStopModal} setShowStopModal={setShowStopModal} />
      <div className="recommend-hall-page-body">
        <PageTitle
          title={`선호하는 식사 형태를
모두 선택해 주세요.`}
          type=""
        />
        <div className="recommend-hall-grid recommend-hall-grid--cols-2">
          {mealTypeItems.map((type) => (
            <ImageSelectableCard
              key={`style-item-${type.title}`}
              src={type.src}
              checked={hallData.meal.types.indexOf(type.title) > -1}
              onClick={() => dispatch(setMealType({ type: type.title }))}
            />
          ))}
        </div>
      </div>
      <div className="recommend-hall-page-footer">
        <button
          onClick={goNext}
          className={`btn btn-giant btn-red500 btn-full ${!validate ? "btn-disabled" : ""}`}
          disabled={!validate}
        >
          다음
        </button>
      </div>
    </div>
  );
};

export default MealType;
